
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/silo/[[...address]]",
      function () {
        return require("private-next-pages/silo/[[...address]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/silo/[[...address]]"])
      });
    }
  